import {
  SELECT_CATEGORY, SELECT_COUNTRY,
  REQUEST_TIPS, RECEIVE_TIPS,
} from "./actions";

const initialState = {
  selectedCategory: "",
  selectedCountry: "",
  isFetching: false,
  statistics: {},
};

const tipsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_COUNTRY:
      return {
        ...state,
        selectedCountry: action.country,
      };
    case SELECT_CATEGORY:
      return {
        ...state,
        selectedCategory: action.category,
      };
    case REQUEST_TIPS:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_TIPS:
      return {
        ...state,
        isFetching: false,
        statistics: action.statistics,
      };
    default:
      return state;
  }
};

export default tipsReducer;
